import * as React from 'react';
import Check from 'wix-ui-icons-common/Check';
import s from './solution-overview.scss';
import { BenefitPreviewWrapper, fillWithPreviewBenefits, } from '../../preview-elements/benefit-wrapper';
import { PreviewMode } from '../../preview-elements/preview-context';
import { composer } from '../../../../component-decorators/composer';
import { Box, Text } from 'wix-style-react';
export var DescriptionBenefits = composer()
    .withTranslation()
    .compose(function (_a) {
    var benefits = _a.benefits, appId = _a.appId, t = _a.t;
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return fillWithPreviewBenefits(benefits, t, value.isPreview).map(function (_a, index) {
            var benefit = _a.benefit, shouldReplace = _a.shouldReplace;
            return (React.createElement(Benefit, { benefit: benefit, index: index, shouldReplace: shouldReplace, appId: appId, key: index }));
        });
    }));
});
var Benefit = function (_a) {
    var benefit = _a.benefit, appId = _a.appId, shouldReplace = _a.shouldReplace, index = _a.index;
    return (React.createElement(BenefitPreviewWrapper, { appId: appId, benefit: benefit, shouldReplace: shouldReplace, index: index },
        React.createElement(Box, { key: index, align: "center", direction: "horizontal", verticalAlign: "top", marginBottom: "8px", inline: true },
            React.createElement(Check, { size: "18", className: s.overViewCheckMark }),
            " \u00A0 \u00A0",
            ' ',
            React.createElement(Text, { dataHook: "benefit-" + index }, benefit))));
};
//# sourceMappingURL=description-benefits.js.map